module.exports = __webpack_public_path__ + "static/media/south-western_iberian_text_03.57b98ca1.jpg";